function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 -14.9768L80.75 -15L80.7442 11.6929C78.3171 14.9945 74.2472 16.3875 68.5343 15.8719C59.9649 15.0988 44.9198 8.13749 27.9438 8.13749C16.6264 8.13749 7.56184 11.8028 0.75 19.1333V-14.9768Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M51.9 29.7143C52.1143 29.7143 52.2857 29.8857 52.2857 30.1V50.9286C52.2857 53.8857 49.8857 56.2857 46.8857 56.2857H31.1143C28.1143 56.2857 25.7143 53.8857 25.7143 50.8857V35.1143C25.7143 32.1143 28.1143 29.7143 31.1143 29.7143H51.9ZM51.9 28H31.1143C27.1714 28 24 31.1714 24 35.1143V50.9286C24 54.8286 27.1714 58 31.1143 58H46.9286C50.8286 58 54 54.8286 54 50.8857V30.1C54 28.9429 53.0571 28 51.9 28Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39 52.3428C38.5285 52.3428 38.1428 52 38.1428 51.5714V33.4428C38.1428 33.0142 38.5285 32.6714 39 32.6714C39.4714 32.6714 39.8571 33.0142 39.8571 33.4428V51.5714C39.8571 52 39.4714 52.3428 39 52.3428Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2857 52.3427C30.8143 52.3427 30.4286 52.1713 30.4286 51.957V42.4856C30.4286 42.2713 30.8143 42.0999 31.2857 42.0999C31.7572 42.0999 32.1429 42.2713 32.1429 42.4856V51.957C32.1429 52.1284 31.7572 52.3427 31.2857 52.3427Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M46.7143 52.3429C46.2429 52.3429 45.8572 52.0858 45.8572 51.7429V37.3429C45.8572 37.0001 46.2429 36.7429 46.7143 36.7429C47.1857 36.7429 47.5715 37.0001 47.5715 37.3429V51.7001C47.5715 52.0429 47.1857 52.3429 46.7143 52.3429Z",
  fill: "black"
});

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -15,
    width: 81,
    height: 35
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.4673V18.4614L40.75 15.9644L0.75 13.4673Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8058 15.9268L40.8156 15.9189L40.7979 15.9207L40.7917 15.9251L40.8058 15.9268Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9001 15.9324L80.75 18.4197V13.4275L41.0245 15.9058L40.9001 15.9324Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7838 15.9254L40.7874 15.9209L40.7767 15.9218L40.775 15.9245L40.7838 15.9254Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9224H40.7526V15.9243H40.7579V15.9224Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8505 15.9298L40.8957 15.9138L40.8407 15.9172L40.8202 15.9279L40.8505 15.9298Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7677 15.9199H40.7651V15.927H40.7677V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.4789V29.831L40.75 15.9644L0.75 24.4789Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9642L40.9002 15.9322L40.8505 15.9297L40.75 15.9642Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0244 15.9057L80.75 7.44978V2.09863L40.8958 15.9138L41.0244 15.9057Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8958 15.9139L40.8503 15.9299L40.9 15.9324L41.0244 15.9058L40.8958 15.9139Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8946 31.6591L40.75 15.9644L10.5713 31.6591H17.8946Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8406 15.917L80.75 -4.83837V-11.5034L40.8157 15.919L40.8406 15.917Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8059 15.927L40.75 15.9643L40.8202 15.9279L40.8059 15.927Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8202 15.9279L40.8407 15.9172L40.816 15.9192L40.8062 15.9271L40.8202 15.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3684 31.6591L40.7499 15.9644L23.7343 31.6591H27.3684Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.798 15.9207L80.75 -20.9293V-25.6392H76.2224L40.7874 15.9207H40.798Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7837 15.9253L40.75 15.9643L40.7918 15.9253H40.7837Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7918 15.9254L40.798 15.9209H40.7873L40.7837 15.9254H40.7918Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2054 31.6591L40.7499 15.9644L30.7866 31.6591H33.2054Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7766 15.9215L67.1586 -25.6392H60.7523L40.7695 15.9215H40.7766Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7686 15.9243L40.75 15.9642L40.775 15.9243H40.7686Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7748 15.9199H40.7714V15.927H40.7748V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6613 31.6591L40.75 15.9644L35.7202 31.6591H37.6613Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7633 15.9224L54.0836 -25.6392H48.9367L40.7579 15.9224H40.7633Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9243L40.75 15.9642L40.7632 15.9243H40.7579Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7615 15.9209H40.7598V15.9262H40.7615V15.9209Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6571 31.6591L40.75 15.9644L39.844 31.6591H41.6571Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7525 15.9243L40.7499 15.9235L40.7525 15.9224L43.1502 -25.6392H38.3506L40.7499 15.9642L40.7525 15.9243Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9234L40.7524 15.9242V15.9224L40.75 15.9234Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7806 31.6591L40.75 15.9644L43.8386 31.6591H45.7806Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5641 -25.6392H27.4172L40.7499 15.9642L32.5641 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7125 31.6591L40.75 15.9644L48.2954 31.6591H50.7125Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7496 -25.6392H14.3413L40.7501 15.9642L20.7496 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7665 31.6591L40.75 15.9644L54.1307 31.6591H57.7665Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27774 -25.6392H0.75V-20.9302L40.75 15.9642L5.27774 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9279 31.6591L40.75 15.9644L63.6055 31.6591H70.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 -11.5034V-4.83837L40.75 15.9642L0.75 -11.5034Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75 29.831V24.4789L40.75 15.9644L80.75 29.831Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.09766V7.44968L40.75 15.9642L0.75 2.09766Z",
    style: {
      fill: "var(--color-primary)"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 31,
    r: 10,
    style: {
      fill: "var(--color-primary)"
    }
  }), _ref5, _ref6, _ref7, _ref8));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.cfd66b8a.svg";
export { ForwardRef as ReactComponent };